// @flow

import React from 'react';
import Translate from 'client/components/translate';
import LinkButton from 'client/components/button/linkButton';
import 'client/styles/blog.scss';

type Props = {
  blog: {
    description: string,
    headline: string,
    viewMore: string,
  },
  blogPosts: Array<Object>,
};

const TaxBlog = ({ blogPosts, blog = {} }: Props) => {
  if (!blogPosts || !blogPosts.length) {
    return null;
  }

  return (
    <div className="blog text-center">
      <div className="margin-2 pad-y text-center">
        <h3 className="margin-top grey-2-color">
          <Translate fallback={blog.headline} />
        </h3>
        <div className="center-col-medium grey-2-color pad-top">
          <Translate fallback={blog.description} />
        </div>
      </div>
      <div className="large-flex-row center start row">
        {blogPosts.map(post => (
          <a
            className="post"
            key={post.id}
            href={`https://blog.stridehealth.com${post.fullUrl}`}
            target="_blank"
            rel="noopener noreferrer">
            <div className="image-container" style={{ backgroundImage: `url(${post.assetUrl})` }} />
            <h4 className="normal text-center margin-top grey-2-color">{post.title}</h4>
          </a>
        ))}
      </div>

      <LinkButton
        className="ghost-button margin-2"
        href="https://blog.stridehealth.com/taxes"
        target="_blank"
        rel="noopener noreferrer">
        <Translate fallback={blog.viewMore} />
      </LinkButton>
    </div>
  );
};

export default TaxBlog;
